export const ICONS = {
  PERSONAL_INFO: 'assets/images/side-menu/mobile/Icon_personalInfo.svg',
  TRANSACTION_HISTORY: 'assets/images/side-menu/mobile/Icon_history.svg',
  TRANSACTION_HISTORY_EXPIRED_MBC: 'assets/images/history/expired_mbc.svg',
  SUPPORT: 'assets/images/side-menu/mobile/Icon_phone.svg',
  GAME_RULES: 'assets/images/side-menu/mobile/Pravila_igre.svg',
  ABOUT_APP: 'assets/images/side-menu/mobile/About_app.svg',
  HOME: 'assets/images/task-bar/pocetna.svg',
  HOME_SELECTED: 'assets/images/task-bar/pocetna_selected.svg',
  PROMO: 'assets/images/task-bar/promocije.svg',
  PROMO_SELECTED: 'assets/images/task-bar/promocije_selected.svg',
  SCAN: 'assets/images/task-bar/skeniraj.svg',
  SCAN_SELECTED: 'assets/images/task-bar/skeniraj_selected.svg',
  CARD: 'assets/images/task-bar/kartica.svg',
  CARD_SELECTED: 'assets/images/task-bar/kartica_selected.svg',
  PROFILE: 'assets/images/task-bar/profil.svg',
  PROFILE_SELECTED: 'assets/images/task-bar/profil_selected.svg',
  MAX_CAFE: 'assets/images/home-page/ico-cafe.svg',
  MAX_CAFE_SELECTED: 'assets/images/home-page/ico-cafe-active.svg',
  BETTING: 'assets/images/home-page/ico-betting.svg',
  BETTING_SELECTED: 'assets/images/home-page/ico-betting-active.svg',
  INFO_WHITE: 'assets/images/home-page/icon-info-white.svg',
  INFO_GRAY: 'assets/images/home-page/icon-info-grey.svg',
  ALCOHOL_DRINKS: 'assets/images/home-page/catering/new/beer.png',
  NOT_ALCOHOL_DRINKS: 'assets/images/home-page/catering/new/drink.png',
  HOT_DRINKS: 'assets/images/home-page/catering/new/tea.png',
  FILTER_ORANGE: 'assets/images/history/ico-filter-orange.svg',
  FILTER_GRAY: 'assets/images/history/ico-filter-grey.svg',
  ARROW_UP: 'assets/images/button-icons/arrow-up.svg',
  SPECIAL_OFFER: 'assets/images/home-page/specialOffer.png',
  MANUAL_ENTRY_SELECTED: 'assets/images/scanner/manuelni-unos_selected.svg',
  MANUAL_ENTRY: 'assets/images/scanner/manuelni-unos.svg',
  SCANNER_SELECTED: '/assets/images/scanner/skener_selected.svg',
  SCANNER: '/assets/images/scanner/skener.svg',
  SHOPPING_CART_GRAY: 'assets/images/shop/shopping_cart_grey.svg',
  SHOPPING_PRODUCT_INFO: 'assets/images/shop/product_info.svg',
  SHOPPING_ORDERS: 'assets/images/shop/orders.svg',
  SHOPPING_CART_CONFIRM_ORDER: 'assets/images/shop/confirm-shipping.svg',
  TERMS_AND_CONDITIONS: 'assets/images/side-menu/ico-terms-and-conditions.svg',

  ARROW_LEFT: '/assets/images/shop/ico-arrow-left.svg',
  ARROW_LEFT_WHITE: '/assets/images/shop/ico-arrow-left_white.svg',

  PLUS: 'assets/images/shop/ico-plus.svg',
  MINUS: 'assets/images/shop/ico-minus.svg',
  DELETE: 'assets/images/shop/ico-delete.svg',
  LANDBASE_VOUCHER: 'assets/images/vouchers/landbase-voucher.svg',
  ONLINE_VOUCHER: 'assets/images/vouchers/online-voucher.svg',
  ARROW_RIGHT: 'assets/images/button-icons/arrow-right.svg',

  WHITE_ARROW_DOWN: 'assets/images/history/ico-arrow-white.svg',
  LOGO: 'assets/images/home-page/maxloyalty-logo.svg',
  NEW_LOGO: 'assets/images/home-page/maxloyalty-logo-new.svg',
  USERNAME: 'assets/images/login/login_username.svg',
  NEW_USERNAME: 'assets/images/registration/ico-username-new.svg',
  PASSWORD: 'assets/images/login/login_password.svg',
  NEW_PASSWORD: 'assets/images/registration/ico-password-new.svg',
  USER: 'assets/images/registration/ico-user.svg',
  NEW_USER: 'assets/images/registration/ico-user-new.svg',
  PHONE: 'assets/images/registration/ico-phone.svg',
  NEW_PHONE: 'assets/images/registration/ico-phone-new.svg',
  MBC_FRONT_SIDE: 'assets/images/home-page/mbc_front_side.svg',
  NEW_MBC_COIN: 'assets/images/home-page/mbc_coin.svg',
  CHECK_ICON: 'assets/images/home-page/betting/check-circle.svg',
  CLOCK_ICON: 'assets/images/home-page/betting/clock.svg',

  NOTIFICATION_BELL: 'assets/images/notifications/notification_bell.svg',
  BUTTON_MORE: 'assets/images/notifications/btn-more.svg',
  NOTIFICATION_SPORT: 'assets/images/notifications/sport.svg',
  NOTIFICATION_MBC: 'assets/images/notifications/mbc.svg',
  NOTIFICATION_SLOT: 'assets/images/notifications/slot.svg',
  NO_NOTIFICATIONS: 'assets/images/notifications/no-notifications.svg',
  NOTIFICATION_RED_DOT: 'assets/images/notifications/red_dot.svg',

  MARKETPLACE: 'assets/images/task-bar/ico-marketplace.svg',
  MARKETPLACE_SELECTED: 'assets/images/task-bar/ico-marketplace_selected.svg',
  LOGOUT: 'assets/images/side-menu/mobile/Icon_logout.svg',
  EYE: 'assets/images/vouchers/eye.svg',
  EYE_OFF: 'assets/images/vouchers/eye-off.svg',

  VOUCHER_ICON: 'assets/images/vouchers/voucher-icon.svg',

  VOUCHERS_BETTING_IMG: 'assets/images/vouchers/betting-voucher.svg',
  VOUCHERS_BETTING_DETAILS_IMG: 'assets/images/vouchers/betting-detail-voucher.svg',
  VOUCHERS_CASINO_IMG: 'assets/images/vouchers/casino-voucher.svg',
  VOUCHERS_CASINO_DETAILS_IMG: 'assets/images/vouchers/casino-detail-voucher.svg',
  VOUCHERS_VIRTUAL_IMG: 'assets/images/vouchers/lucky-six-voucher.svg',
  VOUCHERS_VIRTUAL_DETAILS_IMG: 'assets/images/vouchers/lucky-six-detail-voucher.svg',
  MIN_PAIRS: 'assets/images/vouchers/min-pairs-condition.svg',
  DEPOSIT: 'assets/images/vouchers/deposit-condition.svg',
  MIN_QUOTA: 'assets/images/vouchers/min-quota-condition.svg',
  EXPIRATION_DATE: 'assets/images/vouchers/expiration_date.svg',

  HEADER_HISTORY: 'assets/images/header/Icon_history.svg',
  HEADER_PROMO: 'assets/images/header/promocije.svg',
  HEADER_PERSONAL_INFO: 'assets/images/header/Icon_personalInfo.svg',
  HEADER_MANUAL_ENTRY: 'assets/images/header/manuelni-unos.svg',
  HEADER_GAME_RULES: 'assets/images/header/Pravila_igre.svg',
  HEADER_ABOUT_APP: 'assets/images/header/About_app.svg',
  HEADER_SCANNER: 'assets/images/header/skener.svg',
  HEADER_SUPPORT: 'assets/images/header/Icon_phone.svg',
  HEADER_CARD: 'assets/images/header/kartica.svg',
  HEADER_SHOPPING_BAG: 'assets/images/header/shopping-bag.svg',
  HEADER_BETTING_TASKS: 'assets/images/header/betting-task.svg',
  HEADER_JACKPOT: 'assets/images/header/jackpot.svg',

  ICO_BETTING: 'assets/images/vouchers/ico-betting.svg',
  ICO_CASINO: 'assets/images/vouchers/ico-casino.svg',
  ICO_PRODUCT: 'assets/images/vouchers/shirt.svg',
  ICO_VIRTUAL: 'assets/images/vouchers/ico-virtual.svg',
  ICO_SLOT: 'assets/images/vouchers/ico-slot.svg',
  IMG_PRODUCT: 'assets/images/vouchers/img-product.png',
  IMG_BETTING: 'assets/images/vouchers/All Sports 2.svg',
  IMG_CASINO: 'assets/images/vouchers/Slot_02.svg',
  IMG_PRODUCT_COVER: 'assets/images/vouchers/img-product-cover.png',
  ICO_NO_IMAGE: 'assets/images/no-image.svg',
  ICO_ARROW_RIGHT: 'assets/images/home-page/ico-arrow-right.svg',

  IMG_AWARD_MBC_BACKGROUND: 'assets/images/betting-tasks/mbc-background.png',
  IMG_AWARD_SPORTS_BACKGROUND: 'assets/images/betting-tasks/sports-background.png',
  IMG_AWARD_SLOT_BACKGROUND: 'assets/images/betting-tasks/slot-background.png',
  IMG_AWARD_GIFT: 'assets/images/betting-tasks/gift.svg',
  IMG_AWARD_COIN: 'assets/images/betting-tasks/coin.png',
  IMG_AWARD_SPORTS: 'assets/images/betting-tasks/sports.png',
  IMG_AWARD_SLOT: 'assets/images/betting-tasks/slot.png',

  MAX_SPIN_BANNER: 'assets/images/home-page/maxspin-banner.png',
  MAX_CAFE_BANNER: 'assets/images/home-page/max-cafe-banner.png',
  BETTING_TASKS_BANNER: 'assets/images/home-page/betting-tasks-banner.png',

  MBC_EXPIRED: 'assets/images/history/ico-mbc-expired.svg',
  MBC_EXPIRED_SELECTED: 'assets/images/history/ico-mbc-expired-selected.svg',
  MBC_MINUS: 'assets/images/history/ico-mbc-minus.svg',
  JACKPOT_LOADING: 'assets/images/home-page/betting/jackpot_loader.svg'
};

export const GIFS = {
  BANNER: 'assets/images/home-page/baner.jpg',
  SCAN: 'assets/gifs/scan.gif',
  SCAN_DARK: 'assets/gifs/scan_black.gif'
};
